import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import colors from 'styleguide/colors';

const TabGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const TabBar = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.align};
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const TabItem = styled.div`
  border: 1px solid ${colors('tertiary', 3)};
  padding: 0px 16px;
  height: 40px;
  display: flex;
  z-index: 5;
  justify-content: center;
  align-items: center;

  /* min-width is not super necessary but makes items a bit more even */
  min-width: 160px;

  background-color: ${(props) => (props.active ? colors('tertiary', 3) : 'white')};
  color: ${(props) => (props.active ? colors('tertiary', -1) : colors('tertiary', 2))};

  font-weight: 600;
  font-size: 16px;

  cursor: pointer;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  transition: all 0.15s ease-out 0s;
`;

export const TabGroup = ({ children, align = 'center' }) => {
  const [activeTab, setActiveTab] = useState(0);
  const childrenArray = React.Children.toArray(children);
  return (
    <TabGroupContainer>
      <TabBar align={align}>
        {childrenArray.map((child, index) => (
          <TabItem key={child.key} active={index === activeTab} onClick={() => setActiveTab(index)}>
            {child.props.title}
          </TabItem>
        ))}
      </TabBar>
      {childrenArray[activeTab]}
    </TabGroupContainer>
  );
};

TabGroup.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
};

export const Tab = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};

export const ScrollableTab = styled(Tab)`
  overflow: auto;
`;

Tab.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};
